<template>
    <div class="loading-indicator">
        <div
            class="spinner-border spinner-border-sm"
            v-if="small"
        />
        <div
            class="spinner-border"
            v-else
        />
        <h5
            class="fw-light title mt-1"
            v-if="title"
            v-html="title"
        />
        <p
            class="text-center text-muted"
            v-if="subTitle"
            v-html="subTitle"
        />
    </div>
</template>

<script>
    export default {
        name: 'LoadingIndicator',
        props: {
            title: String,
            subTitle: String,
            small: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'node_modules/aven_shared/src/styles/components/loadingIndicator.scss';
    @import '../styles/onboardingV2.scss';

    .dark .loading-indicator {
        background-color: $dark-mode-bg;
    }

    .dark .spinner-border {
        border-color: rgba(255, 255, 255, 0.2);
        border-right-color: $dark-mode-text-primary;
    }

    .dark .title {
        color: $dark-mode-text-primary;
    }

    // Bootstrap's .text-muted utility uses !important, so we need it here
    .dark .text-muted {
        color: $dark-mode-text-secondary !important;
    }
</style>
